import { getMsgFromApiErr } from "@api/api";
import useRequestState from "@hooks/useRequestState";
import { useCallback, useEffect } from "react";

import getExperienceRequests, { ExperienceRequest } from "../getExperienceRequests";

const useGetExperienceRequests = (autoSend?: boolean) => {
  const { reqState, setLoading, setSuccess, setError } = useRequestState<ExperienceRequest[]>([]);

  const send = useCallback(async () => {
    setLoading();
    try {
      const requests = await getExperienceRequests();
      return setSuccess(requests);
    } catch (err: any) {
      return setError(getMsgFromApiErr(err));
    }
  }, [setError, setLoading, setSuccess]);

  useEffect(() => {
    if (autoSend) send();
    // prevents infinite loop
    // eslint-disable-next-line
  }, [autoSend]);

  return { ...reqState, data: reqState.data, send };
};

export default useGetExperienceRequests;
